var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.6738 10.8714C23.923 10.8714 24.1492 10.9802 24.3279 11.1639C24.4944 11.3602 24.5783 11.6039 24.554 11.8614C24.554 11.9464 23.8878 20.3713 23.5073 23.9175C23.269 26.0938 21.8661 27.415 19.7617 27.4513C18.1437 27.4875 16.562 27.5 15.0047 27.5C13.3514 27.5 11.7345 27.4875 10.1651 27.4513C8.13123 27.4025 6.7271 26.0575 6.50099 23.9175C6.10953 20.3588 5.45549 11.9464 5.44334 11.8614C5.43118 11.6039 5.51385 11.3602 5.68161 11.1639C5.84694 10.9802 6.08522 10.8714 6.33565 10.8714H23.6738ZM17.5809 2.5C18.686 2.5 19.6731 3.27124 19.9588 4.37123L20.163 5.28372C20.3284 6.02746 20.9727 6.55371 21.7143 6.55371H25.3589C25.8452 6.55371 26.25 6.95746 26.25 7.4712V7.9462C26.25 8.44744 25.8452 8.86369 25.3589 8.86369H4.64232C4.15482 8.86369 3.75 8.44744 3.75 7.9462V7.4712C3.75 6.95746 4.15482 6.55371 4.64232 6.55371H8.28696C9.02731 6.55371 9.67163 6.02746 9.83818 5.28497L10.029 4.43248C10.3257 3.27124 11.3019 2.5 12.4191 2.5H17.5809Z",
    fill: "#9F0202"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTrash);
export default __webpack_public_path__ + "static/media/IconTrash.9a34adcbebe47ba470160ec169b94c99.svg";
export { ForwardRef as ReactComponent };